import { GAMMA_DESK_ID } from '@/api/chat/constants';
import FlagIcon from '@/assets/svg/sidebar/flag.svg';
import { useStartTypedThread } from '@/pages/communications-v2/hooks/use-start-typed-thread';

import Button from '../Button';

export const BugReportButton = () => {
  const { start, isPending } = useStartTypedThread();

  return (
    <Button
      variant="outline"
      color="tertiary"
      size="sm"
      fullWidth
      disabled={isPending}
      onClick={() =>
        start({
          recipientType: 'GammaDesk',
          recipientId: GAMMA_DESK_ID,
          name: `Bug Report ${new Date().toLocaleDateString()}`,
          type: 'Report',
        })
      }
    >
      <FlagIcon />
      Report a Bug
    </Button>
  );
};
